module.exports = __webpack_public_path__ + "static/media/upload_disable.d17340d6.svg";